import { EventEmitter,Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { BaseService } from './base-service';
import { CommonService } from './common.service';
import * as Enums from './constants';

@Injectable({
  providedIn: 'root'
})
export class ProfileService extends BaseService {
  public userProfile: EventEmitter<any>;
  fileName: string = 'profile.service.ts';
  constructor(private _commonService: CommonService) {
    super();
    this.userProfile = new EventEmitter<any>();
  }

  getProfile(): any {
    try{
    let dataObj = {
      offset:0,
      method:'get',
      api_url:this.getLocalapiBaseURL() + Enums.CONSTANTS.PROFILE_API,
      local_json_file:'local-profile',
      param_data :{ },
      mapcol:false
    }
    let resp = this._commonService.fetchData(dataObj);
    // resp.subscribe((data) => {
    //   if (data.status)
    //     this.userProfile.emit({ data: data.data });
    // });
    return resp;
  }
  catch (error) {
    let obj = {
      fileName: this.fileName,
      functionName: 'getProfile()',
      error: error
    }
    this._commonService.systemException(obj);
  }
  }

  }
